import React, { useEffect, useState } from "react";
import Cookies from 'js-cookie'

export const getAccessToken = () => Cookies.get('access_token')
export const getRefreshToken = () => Cookies.get('refresh_token')
export const isAuthenticated = () => !!getAccessToken()

// The server issues 1-year tokens (Doorkeeper access_token_expires_in). Without
// an explicit expiry js-cookie writes a session cookie that dies on browser
// close, which silently logs users out -- and would permanently orphan a guest,
// whose cookie is their only credential.
const COOKIE_OPTIONS = { expires: 365, sameSite: 'Lax' }

export const setSession = (token, username, { guest = false } = {}) => {
  Cookies.set('access_token', token, COOKIE_OPTIONS)
  Cookies.set('username', username, COOKIE_OPTIONS)

  if (guest) {
    Cookies.set('guest', 'true', COOKIE_OPTIONS)
  } else {
    Cookies.remove('guest')
  }
}

export const clearSession = () => {
  Cookies.remove('access_token')
  Cookies.remove('username')
  Cookies.remove('guest')
}

// Display-only. The server never reads this; authorization always comes from
// the token's resource_owner_id, so tampering with it gains nothing.
export const isGuest = () => Cookies.get('guest') === 'true'

export const getAuthState = () => {
  if (!isAuthenticated()) return 'anonymous'
  return isGuest() ? 'guest' : 'registered'
}

const redirectToLogin = () => {
  window.location.replace(`/`)
  // or history.push('/login') if your Login page is inside the same app
}

export const authenticate = async () => {
  // Not currently using refresh_token may be a todo
  if (getRefreshToken()) {
    try {
      const tokens = await refreshTokens() // call an API, returns tokens

      const expires = (tokens.expires_in || 60 * 60) * 1000
      const inOneHour = new Date(new Date().getTime() + expires)

      // you will have the exact same setters in your Login page/app too
      Cookies.set('access_token', tokens.access_token, { expires: inOneHour })
      Cookies.set('refresh_token', tokens.refresh_token)

      return true
    } catch (error) {
      redirectToLogin()
      return false
    }
  }

  redirectToLogin()
  return false
}
